import { gql } from '@apollo/client';

export const fetchInvoicesForEntitlementQuery = gql`
  query fetchInvoicesForEntitlement($id: String, $searchOptions: ConnectionSearchOptions) {
    entitlementDetails(id: $id) {
      id
      transactionAccountId
      invoices(searchOptions: $searchOptions) {
        totalCount
        nodes {
          id
          status
          invoiceNumber
          sourceSystem
          paymentMethod
          paymentMethodId
          transactionAccountId
          creditCard {
            last4Numbers
            cardHolderName
            expirationMonth
            expirationYear
            brand
          }
          paymentOnTermsDetails {
            id
            type
            terms {
              invoiceDueDays
            }
            default
          }
          pdfLink
          dueDate
          createdDate
          itemsTotal
          grandTotal
          paymentCurrency
          refunds {
            id
            type
            creditNoteNumber
            sourceSystem
            total
            currency
            status
            arn
          }
          dunningStatus {
            errorCode
          }
          transactionAccount {
            transactionAccountNumber
            id
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;
